import React, {useRef, useState} from "react";

import Aux from "../../../../../../../hoc/Auxiliary"
import TopicConfiguration from "./TopicConfiguration";
import {deleteTopicsQueries} from "../../../../../../../api/file/upload-service";
import {Divider} from 'primereact/divider';
import {Checkbox} from "primereact/checkbox";
import {Button} from 'primereact/button';
import {ConfirmPopup} from "primereact/confirmpopup";
import {Toast} from "primereact/toast";
import classes from "../../../DataVisualisation.module.css"

const TopicsConfigurations = (props) => {

    const [checkedTopics, setCheckedTopics] = useState([]);
    const [selectAllChecked, setSelectAllChecked] = useState(false);
    const [confirmPopupVisible, setConfirmPopupVisible] = useState(false);
    const [deleteInProgress, setDeleteInProgress] = useState(false);
    const toast = useRef(null);
    const buttonEl = useRef(null);


    let addCheckedTopic = (category, topic, queryName) => {
        let el = {
            category: category.id, topic: topic.id, queryName: queryName
        }
        setCheckedTopics([...checkedTopics, el])
    }

    let removeCheckedTopic = (category, topic, queryName) => {
        let el = {
            category: category.id, topic: topic.id, queryName: queryName
        }
        let index = checkedTopics.findIndex(z => z.topic === el.topic);
        checkedTopics.splice(index, 1)
        setCheckedTopics([...checkedTopics])
    }
    let deleteSelectedTopic = () => {
        let el = {
            dataCollectionId: props.dataCollection.id, details: props.topicsDetails.filter(s => s.isChecked)
        }
        deleteTopicsQueries(el).then(res => {
            if (res.status === 200) {
                props.setTopicsDetails(res.content);
            }
            setDeleteInProgress(false)
        })
    }
    let selectAll = () => {

        if (selectAllChecked) {
            props.topicsDetails.forEach(sd => sd.isChecked = false);
            setSelectAllChecked(false);

        } else {
            props.topicsDetails.forEach(sd => sd.isChecked = true);
            setSelectAllChecked(true);

        }
    }

    let accept = () => {
        setDeleteInProgress(true)
        setConfirmPopupVisible(false)
        deleteSelectedTopic();

    }

    let reject = () => {
        setConfirmPopupVisible(false)
    }

    return (<Aux>

        <div className="grid">
            <div className={"col-6 p-0 m-0"}>
                <div>
                    <Checkbox inputId="selectAll"
                              checked={selectAllChecked}
                              onChange={e => selectAll()}
                              value="Select all"/>
                    {selectAllChecked ? <label htmlFor="selectAll" className="ml-2">Unselect all</label> :
                        <label htmlFor="selectAll" className="ml-2">Select all</label>}

                </div>
            </div>
            <div className={"col-6 p-0 m-0"}>
                <div className={"flex flex-row-reverse"}>
                    {deleteInProgress ?
                        <Button icon="pi pi-spin pi-spinner"
                                disabled={true}
                                data-pr-at="left+5 top"
                                className=" p-button-rounded-sm p-button-text"
                                style={{height: '0.5rem', width: '1.5rem', color: '#487c84'}}
                        />
                        : <Button icon="pi pi-trash"
                                  ref={buttonEl}
                                  visible={!deleteInProgress}
                                  tooltip="Delete queries for selected topics"
                                  tooltipOptions={{position: 'top', showOnDisabled: true}}
                                  disabled={props.topicsDetails.filter(sd => sd.isChecked).length === 0}
                                  onClick={() => setConfirmPopupVisible(true)}
                                  className=" p-button-rounded-sm p-button-text"
                                  style={{height: '0.5rem', width: '1.5rem', color: '#487c84'}}
                        />}

                    <Toast ref={toast}/>
                    <ConfirmPopup target={buttonEl.current} visible={confirmPopupVisible}
                                  message="Are you sure you want to delete selected queries ?"
                                  icon="pi pi-exclamation-triangle"
                                  dismissable={false}
                                  accept={accept}
                                  acceptClassName={classes.confirmBtn}
                                  reject={reject}
                                  rejectClassName={classes.rejectBtn}
                    />
                </div>
            </div>
            <div className={"col-12 p-0 m-0 "}>
                <Divider/>
            </div>

            {props.category.topics.map((s, i) => {

                return (<div className="col-3" key={props.category.id + "" + s.id + "" + i}>
                    <TopicConfiguration topic={s} category={props.category}
                                        dataCollection={props.dataCollection}
                                        setTopicsDetails={props.setTopicsDetails}
                                        topicsDetails={props.topicsDetails}
                                        checkedTopics={checkedTopics}
                                        topicDetails={props.topicsDetails.filter(sh => sh.topicId === s.id)}
                                        selectTopic={(cat, topic, queryName) => addCheckedTopic(cat, topic, queryName)}
                                        removeTopic={(cat, topic, queryName) => removeCheckedTopic(cat, topic, queryName)}
                    />
                </div>)
            })}
        </div>
    </Aux>)
}

export default TopicsConfigurations;
